export default __webpack_public_path__ + "static/media/flag18.532a7742.jpg";